import L from 'leaflet';
export const defaultViewport = {
    center: L.latLng(1, 20),
    zoom: 3.25,
};
export const boundariesZoomLimit = 6;
